export const IMAGE_TYPES = ["jpg", "jpeg", "png", "gif", "bmp", "svg"];
export const VIDEO_TYPES = ["mp4", "avi", "mov", "wmv", "flv"];
export const AUDIO_TYPES = ["mp3", "wav", "flac", "aac"];
export const DOC_TYPES = ["pdf", "doc", "docx", "txt"];
